import { ethers } from 'ethers';
import Web3Modal from 'web3modal';

export const providerOptions = {};

// Get Web3Modal instance
export const getWeb3Modal = () =>
  new Web3Modal({
    network: 'any',
    cacheProvider: true,
    providerOptions,
  });

// Connect wallet and return provider and signer
export const connectWallet = async () => {
  const web3Modal = getWeb3Modal();
  const instance = await web3Modal.connect();
  const provider = new ethers.providers.Web3Provider(instance, 'any');
  const signer = provider.getSigner();
  return { provider, signer };
};
